module.exports = __webpack_public_path__ + "media/images/health-hover-f11fda0b95506247516ecbef3130e74e.svg";